import { routeTree } from "./routeTree.gen";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { useStyledFavicon } from "@/shared/hooks/useStyledFavicon";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { CrashErrorBoundary } from "@/components/CrashErrorBoundary/CrashErrorBoundary";

import { ClientProviders } from "./components/Providers";
import type { InitialCulture } from "@/services/culture/bootstrap";

// Create a new router instance with preloading on intent with a delay
const router = createRouter({
  routeTree,
  defaultPreload: "intent", // Preload routes on hover/focus
  defaultPreloadDelay: 100, // Small delay before preloading (100ms)
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

gsap.registerPlugin(useGSAP);

// Main app component
type AppProps = {
  initialCulture?: InitialCulture;
};

const App = ({ initialCulture }: AppProps) => {
  useStyledFavicon({ fallbackFaviconUrl: "/emblem.svg" });

  return (
    <CrashErrorBoundary>
      <ClientProviders initialCulture={initialCulture}>
        <RouterProvider router={router} />
      </ClientProviders>
    </CrashErrorBoundary>
  );
};

export default App;
